module.exports = __webpack_public_path__ + "img/dog-01-cycle.1ae0d1db.png";